/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request to open a proctored exam session.
 */
export interface OpenExamRequest {
  [key: string]: unknown;
}
